export const operationsListPageInitValue = {
  data: {
    society: null,
    societyNominalValue: 0,
    operationsTotal: 0,
    operations: [],
    page: 0,
    rowsPerPage: 0,
    isAdmin: false,
    isReadOnly: false,
    isLoading: false,
  },
  actions: {
    handleChangePage: () => {},
    handleChangeRowsPerPage: () => {},
    handleChangeFilter: () => {},
    handleEdit: () => {},
  },
};
